import SvgIcon from "@mui/material/SvgIcon";

export default function DiceD20Icon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 48 48">
            <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="m44.338 29.816l-5.111-20.5L18.889 3.5L3.662 18.184l5.111 20.5L29.111 44.5z"
            />
            <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="m37.746 29.13l1.481-19.814l-18.415 1.898l-17.15 6.97l10.61 16.8l14.84 9.516z"
            />
            <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="m37.746 29.13l-23.475 5.853l6.541-23.77zM20.812 11.215L18.889 3.5m18.857 25.63l6.592.686m-30.067 5.167l-5.498 3.7"
            />
        </SvgIcon>
    );
}